/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';

const hostUrl = "";

export default {

    getProfileSuggestions: () => {
        return axios.get(hostUrl + '/api/general/profileSuggestions')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get provider profile details from provider ID
    getProviderProfileData: (providerUniqueId, unclaimed) => {
        return axios.get(hostUrl + '/api/client/providerProfileData', { params: { providerUniqueId, unclaimed } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    getRSSFeeds: () => {
        return axios.get(hostUrl + '/api/general/rssFeeds')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getFilters: () => {
        return axios.get(hostUrl + '/api/general/filters')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get minimumAgeForClient
    getMinimumAge: () => {
        return axios.get(hostUrl + '/api/general/minimumAge')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get list of providers
    getProviders: (limit, page, query, showUnclaimedProfiles) => {
        return axios.get(hostUrl + '/api/general/providers', { params: { limit: limit, page: page, query: query, showUnclaimedProfiles: showUnclaimedProfiles } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    providerSignup: (provider) => {
        return axios.post(hostUrl + '/api/general/providerSignup', provider)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    contactUs: (name, email, message, token) => {
        return axios.post(hostUrl + '/api/general/contactUs', { name, email, message, token })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    requestCallback: (name, phone, reason) => {
        return axios.post(hostUrl + '/api/general/requestCallback', { name, phone, reason })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    feedback: (title, email, name, phone, message, token) => {
        return axios.post(hostUrl + '/api/general/feedback', { title, email, name, phone, message, token })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    errorReport: (errorId, name, email, message, token) => {
        return axios.post(hostUrl + '/api/general/errorReport', { errorId, name, email, message, token })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    logError: (errorAt, errorWhile, errorDetail) => {
        return axios.post(hostUrl + '/api/general/logError', { errorAt, errorWhile, errorDetail })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    // Get maintenance status
    getMaintenanceStatus: () => {
        return axios.get(hostUrl + '/api/general/maintenance')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get appVersion
    getAppVersion: () => {
        return axios.get(hostUrl + '/api/general/appVersion')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get timeZones
    getTimeZones: () => {
        return axios.get(hostUrl + '/api/general/timeZones')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },



    getServices: (limit, page, query) => {
        return axios.get(hostUrl + '/api/general/services', { params: { limit: limit, page: page, name: query } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getService: (id) => {
        return axios.get(hostUrl + '/api/general/service', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postServiceRequest: (serviceRequestDetails) => {
        return axios.post(hostUrl + '/api/general/serviceRequest', { serviceRequestDetails: serviceRequestDetails })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getUnclaimedProfiles: (limit, page, search) => {
        return axios.get(hostUrl + '/api/general/unclaimedScrapeProviderProfiles', { params: { limit: limit, page: page, search: search } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    postClaimProfileRequest: (profile) => {
        return axios.post(hostUrl + '/api/general/claimProviderProfileRequest', { profile })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getProvidersOnHome: () => {
        return axios.get(hostUrl + '/api/general/providersOnHome')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getFreeProviderSubscriptionPlan: () => {
        return axios.get(hostUrl + '/api/general/freeProviderSubscriptionPlan')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getProviderSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/general/providerSubscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getFAQs: () => {
        return axios.get(hostUrl + '/api/general/faqs')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    getPolicy: (type) => {
        return axios.get('/api/general/policy/' + type)
        .then(res => {
            return res.data;
        })
        .catch(err => {
            throw err.response.data;
        });
    },

    getProviderForm: (id) => {
        return axios.get(hostUrl + '/api/general/providerForm', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    submitProviderForm: (formId, formName, response) => {
        return axios.post(hostUrl + '/api/general/providerForm', { formId, formName, response })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

}